import { Stepper, StepperProps } from "app/core/components/Stepper"

export const steps: StepperProps["steps"] = [
  {
    label: "Student Info",
    href: (params) => `/star/${params.orderId}/1`,
  },
  {
    label: "Billing & Checkout",
    href: (params) => `/star/${params.orderId}/2`,
  },
]

export const StarStepper = () => {
  return <Stepper steps={steps} />
}
